import { handleActions } from 'redux-actions';
import { constants } from './actions';


export const initialState = {
  config: null,
  serverParams: {},
};

const handleSetAppConfig = (state, { payload }) => (
  {
    ...state,
    config: payload,
  });

export default handleActions({
  [constants.setAppConfig]: handleSetAppConfig,
}, initialState);
